import {
  MenuType,
  StatusOptions
} from '@/common/commonDTO'

// 菜单结构
export function funMenu(arr, pid, menuData) {
  let authorityData = []
  if (arr) {
    arr.forEach((item, index) => {
      if (item.data) {
        let routes = new Array()
        if (item.data.route) {
          routes = item.data.route.split(";");
        } else {
          routes.push(item.id)
          routes.push(item.data.route)
        }
        menuData.push({
          id: routes[0],
          name: item.data.name,
          href: routes[1],
          parentId: pid,
          status: item.data.status
        })
        if (item.mpttVOList && item.mpttVOList.length > 0) {
          authorityData = funFunctionAuthority(item.mpttVOList, authorityData)
        }
      } else {
        item.id = item.id
        item.name = 'null'
        item.href = ''
        item.parentId = pid
        item.status = 1
      }
    })
  }
  return [menuData, authorityData]
}

// 按钮权限
export function funFunctionAuthority(arr, authorityData) {
  arr.forEach((item, index) => {
    if (item.data) {
      if (item.data.route) {
        authorityData.push(item.data.route)
      }
      if (item.mpttVOList && item.mpttVOList.length > 0) {
        funFunctionAuthority(item.mpttVOList, authorityData)
      }
    }
  })
  return authorityData
}

// 项目权限

export function funProjectItemAuthority(arr) {
  let temp = []
  arr.forEach(item => {
    if (item && item.route) {
      temp.push(item.route)
    }
  })
  return temp
}

export function funProjectAuthority(arr, authorityData) {
  console.log('funProjectAuthorityfunProjectAuthorityfunProjectAuthority')
  // debugger
  let temp = []
  arr.forEach((item, index) => {
    if (item.platformPermissionVOList && item.platformPermissionVOList.length > 0) {
      temp = funProjectItemAuthority(item.platformPermissionVOList)
    }
    console.log('itemitemitemitemitemitem:', item)
    console.log('temptemptemptemptemp:', temp)
    authorityData.push({
      projectId: item.projectId,
      items: temp
    })
  })
  return authorityData
}

export function getProjectItemAuthority(arr, authorityData) {
  arr.forEach(item => {
    // debugger
    if (item) {
      if (item.data.route) {
        authorityData.push(item.data.route)
      }
      if (item.mpttVOList && item.mpttVOList.length > 0) {
        getProjectItemAuthority(item.mpttVOList, authorityData)
      }
    }
  })
  return authorityData
}


function getBlob(url, cb) {

  var xhr = new XMLHttpRequest();

  xhr.open('GET', url, true);

  xhr.responseType = 'blob';

  xhr.onload = function () {

    if (xhr.status === 200) {

      cb(xhr.response);

    }

  };

  xhr.send();

}

function saveAs(blob, filename) {

  if (window.navigator.msSaveOrOpenBlob) {

    navigator.msSaveBlob(blob, filename);

  } else {

    var link = document.createElement('a');

    var body = document.querySelector('body');

    link.href = window.URL.createObjectURL(blob);

    link.download = filename;

    // fix Firefox

    link.style.display = 'none';

    body.appendChild(link);

    link.click();

    body.removeChild(link);

    window.URL.revokeObjectURL(link.href);

  };

}

export function download(url, filename) {

  getBlob(url, function (blob) {
    saveAs(blob, filename);
  });

};



// WEBPACK FOOTER //
// ./src/utils/common.js